import { isEnvironment } from './environment'

export function getServiceUrl(service: string, version: string) {
  switch (service) {
    case 'orderApi':
      return getOrderUrl(version)
    case 'foodApi':
      return getFoodUrl(version)
    case 'checkoutApi':
      return getCheckoutUrl(version)
    default:
      return ''
  }
}

function getOrderUrl(version: string) {
  if (isEnvironment('development')) {
    return `https://api-dev.icapronto.se/svc-order/${version}`
  }
  else if (isEnvironment('testing')) {
    return `https://api-dev.icapronto.se/svc-order/${version}`
  }
  else if (isEnvironment('staging')) {
    return `https://api-staging.icapronto.se/svc-order/${version}`
  }
  else if (isEnvironment('production')) {
    return `https://api.icapronto.se/svc-order/${version}`
  }
}

function getFoodUrl(version: string) {
  if (isEnvironment('development')) {
    return `https://api-dev.icapronto.se/app-food/${version}`
  }
  else if (isEnvironment('testing')) {
    return `https://api-dev.icapronto.se/app-food/${version}`
  }
  else if (isEnvironment('staging')) {
    return `https://api-staging.icapronto.se/app-food/${version}`
  }
  else if (isEnvironment('production')) {
    return `https://api.icapronto.se/app-food/${version}`
  }
}

function getCheckoutUrl(version: string) {
  if (isEnvironment('development')) {
    return `https://api-dev.icapronto.se/svc-checkout/${version}`
  }
  else if (isEnvironment('testing')) {
    return `https://api-dev.icapronto.se/svc-checkout/${version}`
  }
  else if (isEnvironment('staging')) {
    return `https://api-staging.icapronto.se/svc-checkout/${version}`
  }
  else if (isEnvironment('production')) {
    return `https://api.icapronto.se/svc-checkout/${version}`
  }
}